export function getDay(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}
